import styled from 'styled-components';

const Form = styled.form`
  margin-bottom: 160px;
`;

export { Form };
